module.exports = __webpack_public_path__ + "img/P150T_weapon_150.64f77c12.png";